var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormShell',{attrs:{"title":_vm.$t('title'),"show-back-btn":"","next-btn-text":_vm.$t('nextBtn'),"subtext":_vm.$t('subtext')},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('ServiceFormStep',{attrs:{"progress-value":_vm.progressValue}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }